import spinnerHttpRequest from '@/api/spinner-http-request';
import {CompanyInfoT, ContractT, FileT} from '@/types/company/company-types';

/**
 * @description 회사 정보 > 회사 정보 조회 API
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/기업정보/get_3
 */
const fetchCompanyInfo = async () => {
  const response = await spinnerHttpRequest.get<NonNullable<CompanyInfoT>>(
    '/companies',
  );

  return response.data;
};

const fetchEncodedCompanyInfo = async (encodedInfo: string) => {
  const response = await spinnerHttpRequest.get<{
    encCompanyId: string;
    encCompanyName: string;
  }>(`/sign-up/distinct/${encodedInfo}`);
  return response.data;
};


/**
 * @description 사업자등록증 파일 다운로드
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/기업정보/downloadBusinessLicenseFile
 * 고정된 api path뒤에 키값 그대로 넣어 호출
 * 예)
 * /companies/file/{key}
 */
const getBusinessLicenseFile =  async (key: string)  => {
  const response = await spinnerHttpRequest.get<Blob>(`/companies/file/${key}`, {
    responseType: 'blob',
  });
  return response.data;
};


/**
 * @description 회사 정보 > 포인트정보
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/기업정보/get_3
 */
const fetchContractInfo = async () => {
  const response = await spinnerHttpRequest.get<NonNullable<ContractT>>(
    '/contracts/latest',
  );
  return response.data;
};

/**
 * @description 포인트 계약정보 파일 다운로드
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/%ED%8F%AC%EC%9D%B8%ED%8A%B8%20%EA%B3%84%EC%95%BD%20%EC%A0%95%EB%B3%B4
 */
const getContractsFile =  async (key: string)  => {
  const response = await spinnerHttpRequest.get<Blob>(`/contracts/file/${key}`,{
    responseType: 'blob',
  });
  return response.data;
};


export {fetchCompanyInfo, fetchEncodedCompanyInfo, getBusinessLicenseFile, fetchContractInfo, getContractsFile};
